import { render, staticRenderFns } from "./tempNotice.vue?vue&type=template&id=623e0e94&scoped=true"
import script from "./tempNotice.vue?vue&type=script&lang=js"
export * from "./tempNotice.vue?vue&type=script&lang=js"
import style0 from "./tempNotice.vue?vue&type=style&index=0&id=623e0e94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e0e94",
  null
  
)

export default component.exports